// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_invoice/create_purchase_invoice.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InventoryItem } from "../inventory/common_pb.js";
import { PaymentMethod, PaymentType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreatePurchaseInvoiceRequest
 */
export class CreatePurchaseInvoiceRequest extends Message<CreatePurchaseInvoiceRequest> {
  /**
   * ID of the supplier
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * List of inventory items to be included in the purchase invoice
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryItem items = 2;
   */
  items: InventoryItem[] = [];

  /**
   * Unique invoice number
   *
   * @generated from field: string invoice_number = 3;
   */
  invoiceNumber = "";

  /**
   * Date of the invoice
   *
   * @generated from field: int32 invoice_date = 4;
   */
  invoiceDate = 0;

  /**
   * Due date for payment
   *
   * @generated from field: int32 delivery_date = 5;
   */
  deliveryDate = 0;

  /**
   * ID of the purchase order associated with this invoice
   *
   * @generated from field: string purchase_order_id = 6;
   */
  purchaseOrderId = "";

  /**
   * Payment method used for the purchase invoice
   *
   * @generated from field: com.neulink.pharmacy.PaymentMethod payment_method = 7;
   */
  paymentMethod = PaymentMethod.UNSPECIFIED;

  /**
   * Type of payment (e.g., FULL, PARTIAL)
   *
   * @generated from field: com.neulink.pharmacy.PaymentType payment_type = 8;
   */
  paymentType = PaymentType.UNSPECIFIED;

  /**
   * @generated from field: string stock_point_id = 9;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<CreatePurchaseInvoiceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePurchaseInvoiceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: InventoryItem, repeated: true },
    { no: 3, name: "invoice_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "invoice_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "delivery_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payment_method", kind: "enum", T: proto3.getEnumType(PaymentMethod) },
    { no: 8, name: "payment_type", kind: "enum", T: proto3.getEnumType(PaymentType) },
    { no: 9, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePurchaseInvoiceRequest {
    return new CreatePurchaseInvoiceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePurchaseInvoiceRequest {
    return new CreatePurchaseInvoiceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePurchaseInvoiceRequest {
    return new CreatePurchaseInvoiceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePurchaseInvoiceRequest | PlainMessage<CreatePurchaseInvoiceRequest> | undefined, b: CreatePurchaseInvoiceRequest | PlainMessage<CreatePurchaseInvoiceRequest> | undefined): boolean {
    return proto3.util.equals(CreatePurchaseInvoiceRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreatePurchaseInvoiceResponse
 */
export class CreatePurchaseInvoiceResponse extends Message<CreatePurchaseInvoiceResponse> {
  /**
   * @generated from field: string purchase_invoice_id = 1;
   */
  purchaseInvoiceId = "";

  /**
   * Unique invoice number
   *
   * @generated from field: string purchase_invoice_number = 2;
   */
  purchaseInvoiceNumber = "";

  constructor(data?: PartialMessage<CreatePurchaseInvoiceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePurchaseInvoiceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purchase_invoice_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePurchaseInvoiceResponse {
    return new CreatePurchaseInvoiceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePurchaseInvoiceResponse {
    return new CreatePurchaseInvoiceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePurchaseInvoiceResponse {
    return new CreatePurchaseInvoiceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePurchaseInvoiceResponse | PlainMessage<CreatePurchaseInvoiceResponse> | undefined, b: CreatePurchaseInvoiceResponse | PlainMessage<CreatePurchaseInvoiceResponse> | undefined): boolean {
    return proto3.util.equals(CreatePurchaseInvoiceResponse, a, b);
  }
}

